import "./App.css";

import Two from "./twocomponentsname";

import  Imgdataa from "./Images_display";

function App() {
  return (
    <div className='App'>
    <h1 style={{position:"fixed",textAlign:"center"}}>Web Devloper Role</h1>
    <Two/>
    <Imgdataa/>
    </div>
  );
}

export default App;
